import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import UserControls from 'flarum/forum/utils/UserControls';
export default class MembersPane extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.query = '';
    this.loading = false;
    this.error = '';
    this.results = [];
    this.selected = null;
    this.selectedModel = null;
    this.loadingUser = false;
    this.canViewEmail = false;
    this.memberTab = 'overview';
    this.memberFiles = [];
    this.memberFilesCount = 0;
    this.memberFilesPage = 1;
    this.memberFilesPerPage = 20;
    this.memberFilesPages = 1;
    this.memberFilesJumpPage = '1';
    this.memberFilesLoaded = false;
    this.memberFilesLoading = false;
    this.memberFilesBusy = '';
    this.memberFilesNotice = '';
    this.memberFilesError = '';
    this.memberFilesRequestId = 0;
    this.contentBusy = false;
    this.contentNotice = '';
    this.contentError = '';
    this.sanctionBusy = false;
    this.sanctionNotice = '';
    this.sanctionError = '';
    this.accountActionBusy = false;
    this.accountActionNotice = '';
    this.accountActionError = '';
    this.ipBanBusy = '';
    this.ipBanNotice = '';
    this.ipBanError = '';
    this.memberHistoryTarget = [];
    this.memberHistoryActor = [];
    this.memberHistoryTargetPage = 1;
    this.memberHistoryActorPage = 1;
    this.memberHistoryTargetHasNext = false;
    this.memberHistoryActorHasNext = false;
    this.memberHistoryTargetLoading = false;
    this.memberHistoryActorLoading = false;
    this.memberHistoryTargetLoaded = false;
    this.memberHistoryActorLoaded = false;
    this.memberHistoryError = '';
  }
  api(path) {
    return String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '') + path;
  }
  async search() {
    const query = String(this.query || '').trim();
    if (query.length < 2) {
      this.results = [];
      this.selected = null;
      this.error = 'Saisis au moins 2 caractères.';
      return;
    }
    this.loading = true;
    this.error = '';
    this.selected = null;
    this.selectedModel = null;
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/users') + '?q=' + encodeURIComponent(query)
      });
      this.results = Array.isArray(data.users) ? data.users : [];
      this.canViewEmail = !!data.can_view_email;
      if (this.results.length === 1) {
        await this.selectUser(this.results[0]);
      }
    } catch (e) {
      this.error = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible de rechercher les membres.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  async selectUser(user) {
    this.selected = user;
    this.selectedModel = null;
    this.loadingUser = true;
    this.memberTab = 'overview';

    // Invalide immédiatement un éventuel chargement de l'ancien membre.
    this.memberFilesRequestId++;

    // Aucune donnée du membre précédent ne doit rester affichée.
    this.memberFiles = [];
    this.memberFilesCount = 0;
    this.memberFilesPage = 1;
    this.memberFilesPerPage = 20;
    this.memberFilesPages = 1;
    this.memberFilesJumpPage = '1';
    this.memberFilesLoaded = false;
    this.memberFilesLoading = false;
    this.memberFilesBusy = '';
    this.memberFilesNotice = '';
    this.memberFilesError = '';
    this.memberHistoryTarget = [];
    this.memberHistoryActor = [];
    this.memberHistoryTargetPage = 1;
    this.memberHistoryActorPage = 1;
    this.memberHistoryTargetHasNext = false;
    this.memberHistoryActorHasNext = false;
    this.memberHistoryTargetLoading = false;
    this.memberHistoryActorLoading = false;
    this.memberHistoryTargetLoaded = false;
    this.memberHistoryActorLoaded = false;
    this.memberHistoryError = '';
    try {
      this.selectedModel = await app.store.find('users', String(user.id));
    } catch (e) {
      this.error = 'Impossible de charger les actions Flarum de ce membre.';
    } finally {
      this.loadingUser = false;
      m.redraw();
    }
  }
  nativeModerationControls() {
    if (!this.selectedModel) return [];
    return UserControls.moderationControls(this.selectedModel, this).toArray();
  }
  nativeDestructiveControls() {
    var _this = this;
    if (!this.selectedModel) return [];
    return UserControls.destructiveControls(this.selectedModel, this).toArray().map(item => {
      if (String(item?.itemName || '') !== 'delete' || typeof item?.attrs?.onclick !== 'function') {
        return item;
      }
      const originalOnclick = item.attrs.onclick;
      item.attrs.onclick = function () {
        const name = _this.selected?.display_name || _this.selected?.username || 'ce membre';
        if (!confirm(`ATTENTION : la suppression du compte de ${name} est définitive. Continuer ?`)) {
          return;
        }

        // Flarum affichera ensuite sa propre confirmation native.
        return originalOnclick(...arguments);
      };
      return item;
    });
  }
  moderationControlTab(item) {
    const name = String(item?.itemName || '').toLowerCase();
    if (name === 'edit' || name.includes('edit')) {
      return 'overview';
    }
    if (name === 'suspend' || name === 'spammer' || name.includes('suspend') || name.includes('spam') || name.includes('ban') || name.includes('undesirable')) {
      return 'sanctions';
    }
    if (name.includes('audit') || name.includes('history') || name.includes('log')) {
      return 'history';
    }
    if (name.includes('term') || name.includes('accept') || name.includes('permission') || name.includes('group')) {
      return 'rights';
    }
    return 'overview';
  }
  controlsForTab(tab) {
    return this.nativeModerationControls().filter(item => this.moderationControlTab(item) === tab);
  }
  memberTabButton(tab, label) {
    return m('button.Button', {
      type: 'button',
      className: this.memberTab === tab ? 'Button--primary' : '',
      onclick: () => {
        this.memberTab = tab;
        if (tab === 'contents') {
          this.loadMemberFiles();
        }
        if (tab === 'history') {
          this.loadMemberHistory();
        }
      }
    }, label);
  }
  memberModerationUrl(tab) {
    const params = new URLSearchParams({
      tab,
      author: String(this.selected.id)
    });
    return app.route('val-moderation') + '?' + params.toString();
  }
  async memberContentAction(kind, action) {
    if (!this.selected || this.contentBusy) return;
    const username = this.selected.display_name || this.selected.username;
    const subject = kind === 'posts' ? 'les messages' : 'les discussions';
    const verb = {
      hide: 'masquer',
      restore: 'restaurer',
      delete: 'supprimer définitivement'
    }[action];
    if (!confirm(`${verb.charAt(0).toUpperCase() + verb.slice(1)} tous ${subject} de ${username} ?`)) {
      return;
    }
    if (action === 'delete' && !confirm(`CONFIRMATION DÉFINITIVE : supprimer ${subject} de ${username} ? Cette action est irréversible.`)) {
      return;
    }
    this.contentBusy = true;
    this.contentNotice = '';
    this.contentError = '';
    try {
      const status = action === 'hide' ? 'visible' : action === 'restore' ? 'hidden' : 'all';
      let url;
      let body;
      if (kind === 'posts') {
        url = this.api('/val/moderation/posts/actions');
        body = {
          action,
          all_matching: true,
          author: String(this.selected.id),
          status,
          allow_first_post: false
        };
      } else {
        url = this.api('/val/moderation/discussions/actions');
        body = {
          action,
          all_matching: true,
          filters: {
            author: String(this.selected.id),
            status
          }
        };
      }
      const data = await app.request({
        method: 'POST',
        url,
        body
      });
      let message = Number(data.changed || 0).toLocaleString('fr-FR') + ' élément(s) modifié(s)';
      if (data.unchanged) {
        message += ' · ' + Number(data.unchanged).toLocaleString('fr-FR') + ' déjà dans cet état';
      }
      if (data.protected) {
        message += ' · ' + Number(data.protected).toLocaleString('fr-FR') + ' premier(s) message(s) protégé(s)';
      }
      if (data.denied) {
        message += ' · ' + Number(data.denied).toLocaleString('fr-FR') + ' refusé(s)';
      }
      this.contentNotice = message;
    } catch (e) {
      this.contentError = e?.response?.error || e?.response?.errors?.[0]?.detail || 'L’action n’a pas pu être exécutée.';
    } finally {
      this.contentBusy = false;
      m.redraw();
    }
  }
  formatFileSize(bytes) {
    const value = Number(bytes || 0);
    if (value < 1024) return value + ' o';
    if (value < 1024 * 1024) {
      return (value / 1024).toFixed(1).replace('.', ',') + ' Ko';
    }
    if (value < 1024 * 1024 * 1024) {
      return (value / 1024 / 1024).toFixed(1).replace('.', ',') + ' Mo';
    }
    return (value / 1024 / 1024 / 1024).toFixed(1).replace('.', ',') + ' Go';
  }
  memberFileUrl(file) {
    if (!file?.url) return '';
    try {
      return new URL(file.url, window.location.origin).href;
    } catch (e) {
      return file.url;
    }
  }
  isMemberImageFile(file) {
    if (!file?.url) return false;
    const type = String(file.type || '').toLowerCase();
    if (type.startsWith('image/') || type === 'image') {
      return true;
    }
    try {
      const url = new URL(file.url, window.location.href);
      return /\.(?:avif|bmp|gif|jpe?g|png|svg|webp)$/i.test(url.pathname);
    } catch (e) {
      return false;
    }
  }
  async loadMemberFiles(force, page) {
    if (force === void 0) {
      force = false;
    }
    if (page === void 0) {
      page = null;
    }
    if (!this.selected || this.memberFilesLoading) {
      return;
    }
    const requestedPage = page === null ? Math.max(1, Number(this.memberFilesPage) || 1) : Math.max(1, Number(page) || 1);
    if (this.memberFilesLoaded && !force && requestedPage === this.memberFilesPage) {
      return;
    }
    const memberId = String(this.selected.id);
    const requestId = ++this.memberFilesRequestId;
    this.memberFilesLoading = true;
    this.memberFilesError = '';
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/users/files') + '?user_id=' + encodeURIComponent(memberId) + '&page=' + encodeURIComponent(requestedPage) + '&per_page=' + encodeURIComponent(this.memberFilesPerPage)
      });

      // Le membre a changé pendant la requête :
      // on jette silencieusement cette ancienne réponse.
      if (requestId !== this.memberFilesRequestId || !this.selected || String(this.selected.id) !== memberId) {
        return;
      }
      this.memberFiles = Array.isArray(data.files) ? data.files : [];
      this.memberFilesCount = Math.max(0, Number(data.count) || 0);
      this.memberFilesPage = Math.max(1, Number(data.page) || requestedPage);
      this.memberFilesPerPage = Math.max(1, Number(data.per_page) || 20);
      this.memberFilesPages = Math.max(1, Number(data.pages) || 1);
      this.memberFilesJumpPage = String(this.memberFilesPage);
      this.memberFilesLoaded = true;
    } catch (e) {
      this.memberFilesError = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible de charger les pièces jointes.';
    } finally {
      if (requestId === this.memberFilesRequestId) {
        this.memberFilesLoading = false;
      }
      m.redraw();
    }
  }
  async deleteMemberFile(file) {
    if (!file?.uuid || this.memberFilesBusy) {
      return;
    }
    if (!confirm(`Supprimer définitivement le fichier « ${file.name} » ?`)) {
      return;
    }
    this.memberFilesBusy = file.uuid;
    this.memberFilesNotice = '';
    this.memberFilesError = '';
    try {
      await app.request({
        method: 'DELETE',
        url: this.api('/fof/upload/delete/') + encodeURIComponent(file.uuid)
      });
      await this.loadMemberFiles(true, this.memberFilesPage);
      this.memberFilesNotice = `Fichier « ${file.name} » supprimé.`;
    } catch (e) {
      this.memberFilesError = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible de supprimer ce fichier.';
    } finally {
      this.memberFilesBusy = '';
      m.redraw();
    }
  }
  async deleteAllMemberFiles() {
    if (!this.memberFilesCount || this.memberFilesBusy || !this.selected) {
      return;
    }
    const count = this.memberFilesCount;
    if (!confirm(`Supprimer définitivement les ${count} pièce(s) jointe(s) de ce membre ?`)) {
      return;
    }
    if (!confirm(`DERNIÈRE CONFIRMATION : ${count} fichier(s) vont être supprimés physiquement et retirés de la base. Continuer ?`)) {
      return;
    }
    this.memberFilesBusy = '__all__';
    this.memberFilesNotice = '';
    this.memberFilesError = '';
    let deleted = 0;
    let failed = 0;
    try {
      const fetchPage = async page => {
        return app.request({
          method: 'GET',
          url: this.api('/val/moderation/users/files') + '?user_id=' + encodeURIComponent(this.selected.id) + '&page=' + encodeURIComponent(page) + '&per_page=100'
        });
      };

      /*
       * On constitue d'abord la liste complète.
       * Ainsi les suppressions ne décalent pas les pages
       * pendant qu'on les parcourt.
       */
      const first = await fetchPage(1);
      let allFiles = Array.isArray(first.files) ? [...first.files] : [];
      const pages = Math.max(1, Number(first.pages) || 1);
      for (let page = 2; page <= pages; page++) {
        const data = await fetchPage(page);
        if (Array.isArray(data.files)) {
          allFiles.push(...data.files);
        }
      }

      /*
       * Sécurité contre d'éventuels doublons.
       */
      const unique = new Map();
      for (const file of allFiles) {
        if (file?.uuid) {
          unique.set(file.uuid, file);
        }
      }
      allFiles = [...unique.values()];
      for (let i = 0; i < allFiles.length; i++) {
        const file = allFiles[i];
        try {
          await app.request({
            method: 'DELETE',
            url: this.api('/fof/upload/delete/') + encodeURIComponent(file.uuid)
          });
          deleted++;
        } catch (e) {
          failed++;
        }

        /*
         * Pas besoin de redessiner 4000 fois.
         */
        if ((i + 1) % 10 === 0) {
          m.redraw();
        }
      }
    } catch (e) {
      this.memberFilesBusy = '';
      this.memberFilesError = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible de récupérer la liste complète des pièces jointes.';
      m.redraw();
      return;
    }
    this.memberFilesBusy = '';

    /*
     * Retour propre à la première page après l'opération.
     */
    await this.loadMemberFiles(true, 1);
    if (failed) {
      this.memberFilesError = `${deleted} fichier(s) supprimé(s), ${failed} échec(s).`;
    } else {
      this.memberFilesNotice = `${deleted} fichier(s) supprimé(s).`;
    }
    m.redraw();
  }
  memberFilesPagination() {
    if (!this.memberFilesLoaded || this.memberFilesPages <= 1) {
      return null;
    }
    const current = Math.max(1, Number(this.memberFilesPage) || 1);
    const total = Math.max(1, Number(this.memberFilesPages) || 1);
    const goTo = page => {
      const target = Math.max(1, Math.min(total, Number(page) || 1));
      if (target === current || this.memberFilesLoading || this.memberFilesBusy) {
        return;
      }
      this.loadMemberFiles(true, target);
    };

    /*
     * Première, dernière et deux pages de chaque côté
     * de la page courante.
     */
    const wanted = new Set([1, total, current - 2, current - 1, current, current + 1, current + 2]);
    const pageNumbers = [...wanted].filter(page => page >= 1 && page <= total).sort((a, b) => a - b);
    const numbered = [];
    let previous = 0;
    for (const page of pageNumbers) {
      if (previous && page > previous + 1) {
        numbered.push(m('span.ValMemberFilesPagination-gap', '…'));
      }
      numbered.push(m('button.Button' + (page === current ? '.Button--primary' : ''), {
        type: 'button',
        disabled: page === current || this.memberFilesLoading || !!this.memberFilesBusy,
        onclick: () => goTo(page)
      }, String(page)));
      previous = page;
    }
    const jump = () => {
      goTo(this.memberFilesJumpPage);
    };
    return m('.ValMemberFilesPagination', [m('.ValMemberFilesPager', [m('button.Button', {
      type: 'button',
      disabled: current <= 1 || this.memberFilesLoading || !!this.memberFilesBusy,
      onclick: () => goTo(1)
    }, 'Début'), m('button.Button', {
      type: 'button',
      disabled: current <= 1 || this.memberFilesLoading || !!this.memberFilesBusy,
      onclick: () => goTo(current - 1)
    }, '‹'), ...numbered, m('button.Button', {
      type: 'button',
      disabled: current >= total || this.memberFilesLoading || !!this.memberFilesBusy,
      onclick: () => goTo(current + 1)
    }, '›'), m('button.Button', {
      type: 'button',
      disabled: current >= total || this.memberFilesLoading || !!this.memberFilesBusy,
      onclick: () => goTo(total)
    }, 'Dernière')]), m('.ValMemberFilesJump', [m('span', 'Page'), m('input.FormControl.ValMemberFilesPageInput', {
      type: 'number',
      min: 1,
      max: total,
      value: this.memberFilesJumpPage,
      oninput: event => {
        this.memberFilesJumpPage = event.target.value;
      },
      onkeydown: event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          jump();
        }
      }
    }), m('span', `/ ${total}`), m('button.Button', {
      type: 'button',
      disabled: this.memberFilesLoading || !!this.memberFilesBusy,
      onclick: jump
    }, 'Aller')])]);
  }
  memberFilesPanel(admin) {
    return m('.ValMemberFiles', [m('h3', 'Pièces jointes'), this.memberFilesLoading ? m('.ValMemberFilesLoading', m(LoadingIndicator)) : null, !this.memberFilesLoading && this.memberFilesLoaded && this.memberFilesCount === 0 ? m('p.helpText', 'Aucune pièce jointe associée à ce membre.') : null, !this.memberFilesLoading && this.memberFilesLoaded && this.memberFilesCount > 0 && this.memberFiles.length ? [m('.ValMemberFilesHeader', [m('strong', this.memberFilesCount + ' pièce(s) jointe(s)'), admin ? m('button.Button.Button--danger', {
      type: 'button',
      disabled: !!this.memberFilesBusy,
      onclick: () => this.deleteAllMemberFiles()
    }, this.memberFilesBusy === '__all__' ? 'Suppression…' : 'Tout supprimer') : null]), this.memberFilesPagination(), m('.ValMemberFilesList', this.memberFiles.map(file => m('.ValMemberFile', [m('.ValMemberFile-main', [file.url ? m('a.ValMemberFile-name', {
      href: this.memberFileUrl(file)
    }, file.name || file.uuid) : m('strong.ValMemberFile-name', file.name || file.uuid), m('.ValMemberFile-meta', [file.type || 'Type inconnu', this.formatFileSize(file.size), this.formatDate(file.created_at)].join(' · '))]), file.url && this.isMemberImageFile(file) || admin ? m('.ValMemberFile-actions', [file.url && this.isMemberImageFile(file) ? m('a.Button.ValMemberFile-view', {
      href: this.memberFileUrl(file),
      'data-val-lightbox-title': file.name || file.uuid,
      title: 'Afficher dans la lightbox'
    }, 'Voir') : null, admin ? m('button.Button.Button--danger.ValMemberFile-delete', {
      type: 'button',
      disabled: !!this.memberFilesBusy,
      onclick: () => this.deleteMemberFile(file)
    }, this.memberFilesBusy === file.uuid ? 'Suppression…' : 'Supprimer') : null]) : null])))] : null, this.memberFilesNotice ? m('.Alert.Alert--success', this.memberFilesNotice) : null, this.memberFilesError ? m('.Alert.Alert--error', this.memberFilesError) : null]);
  }
  memberContentsPanel() {
    const admin = !!(app.session && app.session.user && app.session.user.isAdmin && app.session.user.isAdmin());
    return m('.ValMemberTabPanel', [m('.ValMemberContentLinks', [m('a.Button', {
      href: this.memberModerationUrl('messages')
    }, 'Voir ses messages'), m('a.Button', {
      href: this.memberModerationUrl('discussions')
    }, 'Voir ses discussions')]), m('h3', 'Messages'), m('.ValMemberTabActions', [m('button.Button', {
      type: 'button',
      disabled: this.contentBusy,
      onclick: () => this.memberContentAction('posts', 'hide')
    }, 'Masquer tous ses messages'), m('button.Button', {
      type: 'button',
      disabled: this.contentBusy,
      onclick: () => this.memberContentAction('posts', 'restore')
    }, 'Restaurer ses messages masqués'), admin ? m('button.Button.Button--danger', {
      type: 'button',
      disabled: this.contentBusy,
      onclick: () => this.memberContentAction('posts', 'delete')
    }, 'Supprimer définitivement ses messages') : null]), m('p.helpText', 'Les premiers messages des discussions sont protégés ici. Pour agir sur une discussion entière, utilise les actions ci-dessous.'), m('h3', 'Discussions'), m('.ValMemberTabActions', [m('button.Button', {
      type: 'button',
      disabled: this.contentBusy,
      onclick: () => this.memberContentAction('discussions', 'hide')
    }, 'Masquer toutes ses discussions'), m('button.Button', {
      type: 'button',
      disabled: this.contentBusy,
      onclick: () => this.memberContentAction('discussions', 'restore')
    }, 'Restaurer ses discussions masquées'), admin ? m('button.Button.Button--danger', {
      type: 'button',
      disabled: this.contentBusy,
      onclick: () => this.memberContentAction('discussions', 'delete')
    }, 'Supprimer définitivement ses discussions') : null]), this.memberFilesPanel(admin), this.contentNotice ? m('.Alert.Alert--success', this.contentNotice) : null, this.contentError ? m('.Alert.Alert--error', this.contentError) : null]);
  }
  async forceLogout() {
    if (!this.selected || this.sanctionBusy) return;
    const name = this.selected.display_name || this.selected.username;
    if (!confirm(`Forcer la déconnexion de ${name} sur tous ses appareils ?`)) {
      return;
    }
    this.sanctionBusy = true;
    this.sanctionNotice = '';
    this.sanctionError = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/users/logout'),
        body: {
          user_id: Number(this.selected.id)
        }
      });
      const count = Number(data.deleted_tokens || 0);
      if (this.selected?.security) {
        this.selected.security.active_sessions = 0;
        this.selected.security.remember_sessions = 0;
        this.selected.security.last_ip = null;
        this.selected.security.last_user_agent = null;
        this.selected.security.last_session_at = null;
      }
      this.sanctionNotice = count > 0 ? `${count} session(s) invalidée(s).` : 'Aucune session active à invalider.';
    } catch (e) {
      this.sanctionError = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible de forcer la déconnexion.';
    } finally {
      this.sanctionBusy = false;
      m.redraw();
    }
  }
  memberSanctionsPanel() {
    const controls = this.controlsForTab('sanctions');
    return m('.ValMemberTabPanel', [m('.ValMemberTabActions', [...controls, m('button.Button.ValMemberForceLogout', {
      type: 'button',
      disabled: this.sanctionBusy,
      onclick: () => this.forceLogout()
    }, [m('i.fas.fa-sign-out-alt'), m('span', 'Forcer la déconnexion')])]), m('p.helpText', 'La déconnexion forcée invalide uniquement les sessions normales et « se souvenir de moi ». Les jetons développeur/API sont conservés.'), this.sanctionNotice ? m('.Alert.Alert--success', this.sanctionNotice) : null, this.sanctionError ? m('.Alert.Alert--error', this.sanctionError) : null]);
  }
  async unbanMemberIp(ban) {
    if (!ban?.id || this.ipBanBusy) return;
    if (!confirm(`Débannir l’adresse ${ban.address} ?`)) {
      return;
    }
    this.ipBanBusy = ban.address;
    this.ipBanNotice = '';
    this.ipBanError = '';
    try {
      await app.request({
        method: 'POST',
        url: this.api('/val/moderation/users/unban-ip'),
        body: {
          ban_id: Number(ban.id)
        }
      });
      if (this.selected?.security && Array.isArray(this.selected.security.banned_ips)) {
        this.selected.security.banned_ips = this.selected.security.banned_ips.filter(item => Number(item.id) !== Number(ban.id));
      }
      this.ipBanNotice = `Adresse ${ban.address} débannie.`;
    } catch (e) {
      this.ipBanError = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible de débannir cette adresse IP.';
    } finally {
      this.ipBanBusy = '';
      m.redraw();
    }
  }
  async banMemberIp(ip) {
    if (!this.selected || !ip?.address || this.ipBanBusy) {
      return;
    }
    const name = this.selected.display_name || this.selected.username;
    const reason = prompt(`Raison du bannissement de ${ip.address} (facultatif) :`, '');
    if (reason === null) return;
    if (!confirm(`Bannir l’adresse ${ip.address} associée à ${name} ?`)) {
      return;
    }
    this.ipBanBusy = ip.address;
    this.ipBanNotice = '';
    this.ipBanError = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/users/ban-ip'),
        body: {
          user_id: Number(this.selected.id),
          address: ip.address,
          reason: reason.trim()
        }
      });
      if (this.selected?.security) {
        if (!Array.isArray(this.selected.security.banned_ips)) {
          this.selected.security.banned_ips = [];
        }
        this.selected.security.banned_ips.unshift({
          id: Number(data.id),
          address: data.address,
          reason: data.reason || null,
          created_at: data.created_at || null
        });
      }
      this.ipBanNotice = `Adresse ${ip.address} bannie.`;
    } catch (e) {
      this.ipBanError = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible de bannir cette adresse IP.';
    } finally {
      this.ipBanBusy = '';
      m.redraw();
    }
  }
  memberSecurityBlock() {
    const security = this.selected?.security;
    if (!security) return null;
    const bans = Array.isArray(security.banned_ips) ? security.banned_ips : [];
    const postIps = Array.isArray(security.post_ips) ? security.post_ips : [];
    const relatedAccounts = Array.isArray(security.related_accounts) ? security.related_accounts : [];
    return m('.ValMemberSection.ValMemberSecurity', [m('h3', 'Sécurité'), m('.ValMemberSummaryGrid', [m('.ValMemberSummaryItem', [m('span', 'Dernière IP connue'), m('strong', security.last_ip || '—')]), m('.ValMemberSummaryItem', [m('span', 'Dernière activité de session'), m('strong', this.formatDate(security.last_session_at))]), m('.ValMemberSummaryItem', [m('span', 'Sessions actives'), m('strong', Number(security.active_sessions || 0).toLocaleString('fr-FR'))]), m('.ValMemberSummaryItem', [m('span', 'Connexions mémorisées'), m('strong', Number(security.remember_sessions || 0).toLocaleString('fr-FR'))]), m('.ValMemberSummaryItem.ValMemberUserAgent', [m('span', 'Navigateur / appareil'), m('strong', {
      title: security.last_user_agent || ''
    }, security.last_user_agent || '—')])]), m('h4', 'Historique des IP de publication'), postIps.length ? m('ul.ValMemberSecurityIps', postIps.map(ip => m('li', [m('strong', ip.address), m('button.Button.Button--danger.ValMemberIpBanButton', {
      type: 'button',
      disabled: !!this.ipBanBusy,
      onclick: () => this.banMemberIp(ip)
    }, this.ipBanBusy === ip.address ? 'Bannissement…' : 'Bannir'), m('span', ' — ' + Number(ip.post_count || 0).toLocaleString('fr-FR') + ' message' + (Number(ip.post_count || 0) > 1 ? 's' : '')), ip.last_used_at ? m('small', ' · dernière utilisation : ' + this.formatDate(ip.last_used_at)) : null]))) : m('p.helpText', 'Aucune adresse IP enregistrée dans ses messages.'), this.ipBanNotice ? m('.Alert.Alert--success', this.ipBanNotice) : null, this.ipBanError ? m('.Alert.Alert--error', this.ipBanError) : null, m('h4', 'Autres comptes utilisant les mêmes IP'), relatedAccounts.length ? m('ul.ValMemberRelatedAccounts', relatedAccounts.map(account => m('li', [m('a', {
      href: '/u/' + account.user_id + '-' + account.username
    }, account.username), m('span', ' — ' + account.address), m('span', ' — ' + Number(account.post_count || 0).toLocaleString('fr-FR') + ' message' + (Number(account.post_count || 0) > 1 ? 's' : '')), account.last_used_at ? m('small', ' · dernière utilisation : ' + this.formatDate(account.last_used_at)) : null]))) : m('p.helpText', 'Aucun autre compte trouvé sur les IP connues de ce membre.'), m('h4', 'Bannissements IP'), bans.length ? m('ul.ValMemberSecurityBans', bans.map(ban => m('li', [m('strong', ban.address), m('button.Button.ValMemberIpBanButton', {
      type: 'button',
      disabled: !!this.ipBanBusy,
      onclick: () => this.unbanMemberIp(ban)
    }, this.ipBanBusy === ban.address ? 'Débannissement…' : 'Débannir'), ban.reason ? m('span', ' — ' + ban.reason) : null, ban.created_at ? m('small', ' · ' + this.formatDate(ban.created_at)) : null]))) : m('p.helpText', 'Aucune adresse IP bannie liée à ce compte.')]);
  }
  async memberAccountAction(action) {
    if (!this.selected || this.accountActionBusy) return;
    const name = this.selected.display_name || this.selected.username;
    const question = action === 'reset_password' ? `Envoyer à ${name} un lien de réinitialisation du mot de passe ?` : `Renvoyer à ${name} l’e-mail de confirmation de son adresse ?`;
    if (!confirm(question)) return;
    this.accountActionBusy = true;
    this.accountActionNotice = '';
    this.accountActionError = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/users/account-action'),
        body: {
          user_id: Number(this.selected.id),
          action
        }
      });
      if (action === 'reset_password') {
        this.accountActionNotice = 'Lien de réinitialisation du mot de passe envoyé.';
      } else if (data.already_confirmed) {
        this.accountActionNotice = 'Cette adresse e-mail est déjà confirmée.';
      } else {
        this.accountActionNotice = 'E-mail de confirmation renvoyé.';
      }
    } catch (e) {
      this.accountActionError = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible d’effectuer cette action.';
    } finally {
      this.accountActionBusy = false;
      m.redraw();
    }
  }
  memberAccountActions() {
    const admin = !!(app.session && app.session.user && app.session.user.isAdmin && app.session.user.isAdmin());
    if (!admin) return null;
    return m('.ValMemberSection', [m('h3', 'Accès au compte'), m('p.helpText', 'Envoi de liens sécurisés au membre. Aucun mot de passe n’est visible ni choisi par l’administrateur.'), m('.ValMemberTabActions', [m('button.Button', {
      type: 'button',
      disabled: this.accountActionBusy,
      onclick: () => this.memberAccountAction('reset_password')
    }, 'Réinitialiser le mot de passe'), this.selected?.email_confirmed === false ? m('button.Button', {
      type: 'button',
      disabled: this.accountActionBusy,
      onclick: () => this.memberAccountAction('confirm_email')
    }, 'Renvoyer la confirmation e-mail') : null]), this.accountActionNotice ? m('.Alert.Alert--success', this.accountActionNotice) : null, this.accountActionError ? m('.Alert.Alert--error', this.accountActionError) : null]);
  }
  memberOverviewPanel() {
    const controls = this.controlsForTab('overview');
    const admin = !!(app.session && app.session.user && app.session.user.isAdmin && app.session.user.isAdmin());
    const destructive = admin ? this.nativeDestructiveControls() : [];
    return m('.ValMemberTabPanel.ValMemberOverviewPanel', [m('.ValMemberSection', [m('h3', 'Compte'), m('p.helpText', 'Informations générales et paramètres du compte.'), controls.length ? m('.ValMemberTabActions', controls) : m('span.helpText', 'Aucune action générale disponible.')]), this.memberAccountActions(), this.memberSecurityBlock(), admin && destructive.length ? m('.ValMemberSection.ValMemberDangerZone', [m('h3', 'Administration'), m('p.helpText', 'Actions réservées à l’administrateur. La suppression du compte est définitive.'), m('.ValMemberTabActions', destructive)]) : null]);
  }
  memberRightsPanel() {
    const rights = this.controlsForTab('rights');
    const edit = this.controlsForTab('overview').filter(item => String(item?.itemName || '') === 'edit');
    return m('.ValMemberTabPanel', [m('.ValMemberSection', [m('h3', 'Groupes actuels'), m('.ValMemberGroups', this.groupBadges(this.selected)), edit.length ? m('.ValMemberTabActions', edit) : null, m('p.helpText', 'Modifier utilise l’interface native de Flarum pour le compte et les groupes, selon les permissions.')]), rights.length ? m('.ValMemberSection', [m('h3', 'Autres droits et validations'), m('.ValMemberTabActions', rights)]) : null]);
  }
  async loadMemberAudit(kind, page) {
    if (page === void 0) {
      page = 1;
    }
    if (!this.selected) return;
    const target = kind === 'target';
    const loadingKey = target ? 'memberHistoryTargetLoading' : 'memberHistoryActorLoading';
    if (this[loadingKey]) return;
    const memberId = String(this.selected.id);
    const username = String(this.selected.username || '');
    if (!username) return;
    const wantedPage = Math.max(1, Number(page) || 1);
    const limit = 12;
    const offset = (wantedPage - 1) * limit;
    this[loadingKey] = true;
    this.memberHistoryError = '';
    try {
      const results = await app.store.find('audit', {
        filter: {
          [target ? 'user' : 'actor']: username
        },
        page: {
          offset,
          limit
        },
        sort: '-createdAt'
      });

      /*
       * Si on a changé de membre pendant la requête,
       * la réponse ne doit pas polluer la nouvelle fiche.
       */
      if (!this.selected || String(this.selected.id) !== memberId) {
        return;
      }
      if (target) {
        this.memberHistoryTarget = Array.from(results || []);
        this.memberHistoryTargetPage = wantedPage;
        this.memberHistoryTargetHasNext = !!results?.payload?.links?.next;
        this.memberHistoryTargetLoaded = true;
      } else {
        this.memberHistoryActor = Array.from(results || []);
        this.memberHistoryActorPage = wantedPage;
        this.memberHistoryActorHasNext = !!results?.payload?.links?.next;
        this.memberHistoryActorLoaded = true;
      }
    } catch (e) {
      this.memberHistoryError = e?.response?.errors?.[0]?.detail || e?.response?.error || 'Impossible de charger le journal d’audit.';
    } finally {
      if (this.selected && String(this.selected.id) === memberId) {
        this[loadingKey] = false;
      }
      m.redraw();
    }
  }
  async loadMemberHistory() {
    if (!this.selected) return;
    const jobs = [];
    if (!this.memberHistoryTargetLoaded && !this.memberHistoryTargetLoading) {
      jobs.push(this.loadMemberAudit('target', 1));
    }
    if (!this.memberHistoryActorLoaded && !this.memberHistoryActorLoading) {
      jobs.push(this.loadMemberAudit('actor', 1));
    }
    if (jobs.length) {
      await Promise.all(jobs);
    }
  }
  auditActionLabel(action) {
    const labels = {
      'user.logged_in': 'Connexion',
      'user.logged_out': 'Déconnexion',
      'user.created': 'Compte créé',
      'user.deleted': 'Compte supprimé',
      'user.renamed': 'Nom d’utilisateur modifié',
      'user.email_changed': 'Adresse e-mail modifiée',
      'user.password_changed': 'Mot de passe modifié',
      'user.suspended': 'Membre suspendu',
      'user.unsuspended': 'Suspension levée',
      'fof_ban_ips.banned': 'Adresse IP bannie',
      'fof_ban_ips.unbanned': 'Adresse IP débannie',
      'post.created': 'Message publié',
      'post.revised': 'Message modifié',
      'post.hidden': 'Message masqué',
      'post.restored': 'Message restauré',
      'post.deleted': 'Message supprimé',
      'discussion.created': 'Discussion créée',
      'discussion.renamed': 'Discussion renommée',
      'discussion.hidden': 'Discussion masquée',
      'discussion.restored': 'Discussion restaurée',
      'discussion.deleted': 'Discussion supprimée',
      'developer_token_created': 'Jeton développeur créé',
      'val_moderation.user.force_logout': 'Déconnexion forcée',
      'val_moderation.user.password_reset_sent': 'Lien de réinitialisation du mot de passe envoyé',
      'val_moderation.user.email_confirmation_sent': 'Confirmation e-mail renvoyée'
    };
    return labels[action] || action || 'Action inconnue';
  }
  auditActorName(log) {
    const actor = typeof log?.actor === 'function' ? log.actor() : null;
    if (actor) {
      if (typeof actor.displayName === 'function' && actor.displayName()) {
        return actor.displayName();
      }
      if (typeof actor.username === 'function' && actor.username()) {
        return actor.username();
      }
      if (actor.id) {
        return 'Membre #' + actor.id();
      }
    }
    const client = typeof log?.client === 'function' ? log.client() : '';
    return client === 'cli' ? 'Système / CLI' : 'Système';
  }
  auditPayloadText(log) {
    const payload = typeof log?.payload === 'function' ? log.payload() || {} : {};
    const parts = [];
    if (payload.ip) {
      parts.push('IP : ' + payload.ip);
    }
    if (payload.reason) {
      parts.push('Motif : ' + payload.reason);
    }
    if (payload.until) {
      parts.push('Jusqu’au : ' + this.formatDate(payload.until));
    }
    if (payload.old_username || payload.new_username) {
      parts.push('Nom : ' + (payload.old_username || '—') + ' → ' + (payload.new_username || '—'));
    }
    if (payload.discussion_id) {
      parts.push('Discussion #' + payload.discussion_id);
    }
    if (payload.post_id) {
      parts.push('Message #' + payload.post_id);
    }
    if (payload.title) {
      parts.push('Titre : ' + payload.title);
    }
    if (payload.name) {
      parts.push('Nom : ' + payload.name);
    }
    if (payload.old_name || payload.new_name) {
      parts.push('Nom : ' + (payload.old_name || '—') + ' → ' + (payload.new_name || '—'));
    }
    return parts.join(' · ');
  }
  memberAuditRow(log) {
    const action = typeof log?.action === 'function' ? log.action() : '';
    const createdAt = typeof log?.createdAt === 'function' ? log.createdAt() : null;
    const ip = typeof log?.ipAddress === 'function' ? log.ipAddress() : null;
    const details = this.auditPayloadText(log);
    return m('.ValMemberAuditRow', [m('.ValMemberAuditRow-main', [m('strong.ValMemberAuditAction', this.auditActionLabel(action)), m('.ValMemberAuditMeta', [this.formatDate(createdAt), 'par ' + this.auditActorName(log), ip ? 'IP ' + ip : null].filter(Boolean).join(' · ')), details ? m('.ValMemberAuditDetails', details) : null])]);
  }
  memberAuditPager(kind) {
    const target = kind === 'target';
    const page = target ? this.memberHistoryTargetPage : this.memberHistoryActorPage;
    const hasNext = target ? this.memberHistoryTargetHasNext : this.memberHistoryActorHasNext;
    const loading = target ? this.memberHistoryTargetLoading : this.memberHistoryActorLoading;
    return m('.ValMemberAuditPager', [m('button.Button', {
      type: 'button',
      disabled: loading || page <= 1,
      onclick: () => this.loadMemberAudit(kind, page - 1)
    }, '‹ Précédente'), m('span.ValMemberAuditPage', 'Page ' + page), m('button.Button', {
      type: 'button',
      disabled: loading || !hasNext,
      onclick: () => this.loadMemberAudit(kind, page + 1)
    }, 'Suivante ›')]);
  }
  memberAuditList(kind) {
    const target = kind === 'target';
    const logs = target ? this.memberHistoryTarget : this.memberHistoryActor;
    const loading = target ? this.memberHistoryTargetLoading : this.memberHistoryActorLoading;
    const loaded = target ? this.memberHistoryTargetLoaded : this.memberHistoryActorLoaded;
    if (loading && !loaded) {
      return m('.ValMemberAuditLoading', m(LoadingIndicator));
    }
    if (loaded && !logs.length) {
      return m('p.helpText', 'Aucune entrée dans le journal d’audit.');
    }
    return [m('.ValMemberAuditList', logs.map(log => this.memberAuditRow(log))), loaded ? this.memberAuditPager(kind) : null];
  }
  memberHistoryPanel() {
    const controls = this.controlsForTab('history');
    const target = controls.filter(item => String(item?.itemName || '') === 'flarum-audit-user');
    const actor = controls.filter(item => String(item?.itemName || '') === 'flarum-audit-actor');
    return m('.ValMemberTabPanel', [m('.ValMemberSection', [m('h3', 'Actions portant sur ce membre'), m('p.helpText', 'Modifications, sanctions et autres opérations dont ce membre est la cible.'), this.memberAuditList('target'), target.length ? m('.ValMemberTabActions.ValMemberAuditFullLink', target) : null]), m('.ValMemberSection', [m('h3', 'Actions effectuées par ce membre'), m('p.helpText', 'Opérations enregistrées dans le journal d’audit avec ce membre comme acteur.'), this.memberAuditList('actor'), actor.length ? m('.ValMemberTabActions.ValMemberAuditFullLink', actor) : null]), this.memberHistoryError ? m('.Alert.Alert--error', this.memberHistoryError) : null]);
  }
  memberTabContent() {
    if (this.memberTab === 'overview') {
      return this.memberOverviewPanel();
    }
    if (this.memberTab === 'contents') {
      return this.memberContentsPanel();
    }
    if (this.memberTab === 'sanctions') {
      return this.memberSanctionsPanel();
    }
    if (this.memberTab === 'rights') {
      return this.memberRightsPanel();
    }
    if (this.memberTab === 'history') {
      return this.memberHistoryPanel();
    }
    const controls = this.controlsForTab(this.memberTab);
    if (this.loadingUser) {
      return m('.ValMemberTabPanel', m('span.helpText', 'Chargement…'));
    }
    if (!this.selectedModel) {
      return m('.ValMemberTabPanel', m('span.helpText', 'Actions indisponibles.'));
    }
    if (!controls.length) {
      return m('.ValMemberTabPanel', m('span.helpText', 'Aucune action disponible dans cette section.'));
    }
    return m('.ValMemberTabPanel', [m('.ValMemberTabActions', controls)]);
  }
  formatDate(value) {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return new Intl.DateTimeFormat('fr-FR', {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(date);
  }
  memberState(user) {
    if (user.suspended_until) {
      const until = new Date(user.suspended_until);
      if (!Number.isNaN(until.getTime()) && until.getTime() > Date.now()) {
        return 'Suspendu jusqu’au ' + this.formatDate(user.suspended_until);
      }
    }
    return 'Actif';
  }
  groupBadges(user) {
    const groups = Array.isArray(user.groups) ? user.groups : [];
    if (!groups.length) {
      return m('span.ValMemberGroup.ValMemberGroup--none', 'Aucun groupe particulier');
    }
    return groups.map(group => m('span.ValMemberGroup', {
      style: group.color ? {
        borderColor: group.color,
        color: group.color
      } : {}
    }, group.name || 'Groupe ' + group.id));
  }
  resultRow(user) {
    const active = this.selected && Number(this.selected.id) === Number(user.id);
    return m('button.ValMemberResult', {
      type: 'button',
      className: active ? 'is-active' : '',
      onclick: () => {
        this.selectUser(user);
      }
    }, [m('.ValMemberResult-main', [m('strong', user.display_name || user.username), user.display_name && user.display_name !== user.username ? m('span.ValMemberResult-username', '@' + user.username) : null]), m('.ValMemberResult-meta', '#' + user.id + ' · ' + Number(user.comment_count || 0).toLocaleString('fr-FR') + ' message(s)')]);
  }
  detail(user) {
    if (!user) {
      return m('.ValMemberEmpty', 'Sélectionne un membre dans les résultats.');
    }
    return m('.ValMemberCard', [m('.ValMemberCard-header', [m('.ValMemberCard-title', [m('h2', user.display_name || user.username), m('span.ValMemberId', 'ID ' + user.id)]), m('a.Button', {
      href: user.profile_url
    }, 'Voir le profil'), m('button.Button', {
      type: 'button',
      onclick: async () => {
        const data = await app.request({
          method: 'POST',
          url: '/val/moderation/users/impersonate/' + user.id
        });
        window.location.assign(data && data.redirect || '/');
      }
    }, 'Voir comme ce membre')]), user.display_name && user.display_name !== user.username ? m('.ValMemberUsername', '@' + user.username) : null, m('.ValMemberGroups', this.groupBadges(user)), m('.ValMemberSummaryGrid', [m('.ValMemberSummaryItem', [m('span', 'État du compte'), m('strong', this.memberState(user))]), m('.ValMemberSummaryItem', [m('span', 'Inscrit le'), m('strong', this.formatDate(user.joined_at))]), m('.ValMemberSummaryItem', [m('span', 'Dernière activité'), m('strong', this.formatDate(user.last_seen_at))]), m('.ValMemberSummaryItem', [m('span', 'Messages'), m('strong', Number(user.comment_count || 0).toLocaleString('fr-FR'))]), m('.ValMemberSummaryItem', [m('span', 'Discussions'), m('strong', Number(user.discussion_count || 0).toLocaleString('fr-FR'))]), m('.ValMemberSummaryItem', [m('span', 'Adresse e-mail'), m('strong', this.canViewEmail && user.email ? user.email : 'Réservée à l’administrateur')]), m('.ValMemberSummaryItem', [m('span', 'E-mail vérifié'), m('strong', user.email_confirmed === null ? '—' : user.email_confirmed ? 'Oui' : 'Non')])]), m('.ValMemberSubTabs', [this.memberTabButton('overview', 'Vue d’ensemble'), this.memberTabButton('sanctions', 'Sanctions'), this.memberTabButton('contents', 'Contenus'), this.memberTabButton('rights', 'Droits'), this.memberTabButton('history', 'Historique')]), this.memberTabContent()]);
  }
  view() {
    return m('.ValModerationMembers', [m('form.ValMemberSearch', {
      onsubmit: event => {
        event.preventDefault();
        this.search();
      }
    }, [m('.ValMemberSearch-field', [m('label', 'Rechercher un membre'), m('input.FormControl', {
      type: 'search',
      value: this.query,
      placeholder: this.canViewEmail ? 'Pseudo, ID ou e-mail' : 'Pseudo ou ID',
      oninput: event => {
        this.query = event.target.value;
      }
    })]), m('button.Button.Button--primary', {
      type: 'submit',
      disabled: this.loading
    }, this.loading ? 'Recherche…' : 'Rechercher')]), this.error ? m('.Alert.Alert--error', this.error) : null, this.loading ? m('.ValMemberLoading', m(LoadingIndicator)) : null, !this.loading && this.results.length ? m('.ValMemberWorkspace', [m('.ValMemberResults', this.results.map(user => this.resultRow(user))), this.detail(this.selected)]) : null, !this.loading && !this.error && this.query.trim().length >= 2 && !this.results.length ? m('.ValMemberEmpty', 'Aucun membre trouvé.') : null]);
  }
}